"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var CONFIG_FIELD_NAMES = exports.CONFIG_FIELD_NAMES = Object.freeze({
  DATA: "data",
  SCOPES: "scopes",
  RESOLVE: "resolve",
  BREAKPOINTS: "breakpoints",
  API: "api",
  TRANSFORMERS: "transformers",
  ALIASES: "aliases"
});


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/const/config.js
// module id = 174
// module chunks = 168707334958949